import React, { useEffect, useState } from "react";
import {
  Box, Typography, Table, TableBody, TableCell, TableHead, TableRow, Button, CircularProgress, Card,
  CardContent
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchTeacherApplications,
  approveTeacher,
  setTeacherPending,
  downloadTeacherCv,
  downloadTeacherCertificate,   // ✅ import new action
} from "../../../redux/Actions/teacherManagerActions";
import TeacherNavbar from "./TeacherNavbar";
import "./CvManagementPage.css";
import MessageCard from "../../MessageCard/MessageCard";
import NotifyTeacherModal from "./NotifyTeacherModal";

const CvManagementPage = () => {
  const dispatch = useDispatch();
  const { applications, loading } = useSelector((state) => state.teacherManager);

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("success");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);

  useEffect(() => {
    dispatch(fetchTeacherApplications());
  }, [dispatch]);



  const handleApprove = async (teacherId) => {
    try {
      await dispatch(approveTeacher(teacherId));
      setMessage("✅ Access successfully assigned.");
      setMessageType("success");
    } catch {
      setMessage("❌ Something went wrong while approving.");
      setMessageType("error");
    }
  };

  const handleSetPending = async (teacherId) => {
    try {
      await dispatch(setTeacherPending(teacherId));
      setMessage("✅ Status set to pending.");
      setMessageType("success");
    } catch {
      setMessage("❌ Something went wrong while setting pending.");
      setMessageType("error");
    }
  };

  return (
    <div className="cv-management-layout">
      <TeacherNavbar />
      <Box className="cv-management-container">
        <Typography variant="h4" gutterBottom className="cv-management-header">
          Teacher CV Management
        </Typography>

        {message && (
          <MessageCard message={message} type={messageType} onClose={() => setMessage(null)} />
        )}

        {loading ? (
          <CircularProgress />
        ) : applications && applications.length > 0 ? (
             <Card sx={{ maxHeight: 690, display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              sx={{
                px: 2,
                py: 1,
                borderBottom: "1px solid #ddd",
                fontWeight: "bold",
                backgroundColor: "#f5f5f5"
              }}
            >
              Applications List
            </Typography>
            <CardContent
              sx={{
                flex: 1,
                overflowY: "auto",
                p: 0
              }}
            >
              <Table stickyHeader>
                <TableHead>
                <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                  {["First Name", "Last Name", "Email", "CV", "Certificate", "Status", "Has Access", "Action"].map((header) => (
                    <TableCell
                      key={header}
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.95rem",
                        color: "#333",
                        borderBottom: "2px solid #ccc",
                        padding: "12px"
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
                <TableBody>
                  {applications.map((teacher) => {
                    const isConfirmed = teacher.confirmedFromAdmin === true;
                    const isApproved = teacher.status === "approved";
                    const hasAccess = isConfirmed && isApproved;

                    return (
                      <TableRow key={teacher.teacherId}>
                        <TableCell>{teacher.firstName}</TableCell>
                        <TableCell>{teacher.lastName}</TableCell>
                        <TableCell>{teacher.email}</TableCell>
                        <TableCell>
                          {teacher.cvFilename ? (
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() =>
                                dispatch(
                                  downloadTeacherCv(
                                    teacher.teacherId,
                                    teacher.firstName,
                                    teacher.lastName
                                  )
                                )
                              }
                            >
                              Download CV
                            </Button>
                          ) : (
                            "No CV uploaded"
                          )}
                        </TableCell>
                        <TableCell>
                        {teacher.certificateFilename ? (
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() =>
                              dispatch(
                                downloadTeacherCertificate(
                                  teacher.teacherId,
                                  teacher.firstName,
                                  teacher.lastName
                                )
                              )
                            }
                          >
                            Download Certificate
                          </Button>
                        ) : "No Certificate uploaded"}
                      </TableCell>

                        <TableCell>{teacher.status || "N/A"}</TableCell>
                        <TableCell>{hasAccess ? "✅ Yes" : "❌ No"}</TableCell>
                        <TableCell>
                          {teacher.status === "pending" ? (
                            <Button
                              variant="contained"
                              color="success"
                              onClick={() => handleApprove(teacher.teacherId)}
                            >
                              Approve
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="warning"
                              onClick={() => handleSetPending(teacher.teacherId)}
                            >
                              Set Pending
                            </Button>
                          )}
                          <Button
                            variant="contained"
                            color="info"
                            sx={{ display: "block", mt: 1 }}
                            onClick={() => {
                              setSelectedTeacher(teacher);
                              setModalOpen(true);
                            }}
                          >
                            Notify & Process
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        ) : (
          <Typography>No teacher applications found.</Typography>
        )}
      </Box>
              {selectedTeacher && (
              <NotifyTeacherModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                teacher={selectedTeacher}
              />
            )}
    </div>
  );
};

export default CvManagementPage;
